// decorative-elements.tsx - VERSIONE CORRETTA
"use client";
import { motion } from "framer-motion";
import { useMemo } from "react";
import { useMounted } from "./hooks/useMounted";
import { DecorativeElement } from "./decorative-element.config";

interface DecorativeElementsProps {
  elements: DecorativeElement[]; // OBBLIGATORIO - devi sempre passare l'array
  isEnabled?: boolean;
  filterType?: "bee" | "arrow" | "dot" | null;
}

export const DecorativeElements = ({
  elements, // Non più default - sempre richiesto
  isEnabled = true,
  filterType = null,
}: DecorativeElementsProps) => {
  const mounted = useMounted();

  const elementsToRender = useMemo(() => {
    // SICUREZZA: Controlla che elements esista e sia un array
    if (!isEnabled || !elements || !Array.isArray(elements)) {
      return [];
    }

    return filterType
      ? elements.filter((element) => element.type === filterType)
      : elements;
  }, [isEnabled, elements, filterType]);

  // Early return se non è montato
  if (!mounted) return null;

  // SICUREZZA AGGIUNTIVA: Controlla che elementsToRender sia definito
  if (!elementsToRender || !Array.isArray(elementsToRender)) {
    return null;
  }

  return (
    <>
      {elementsToRender.map(
        ({ id, Component, position, animation, className, props = {} }) => (
          <motion.div
            key={id}
            className={`absolute ${position} ${className ?? ""}`}
            animate={animation?.animate}
            transition={animation?.transition}
          >
            <Component {...props} />
          </motion.div>
        )
      )}
    </>
  );
};
